import { Link } from "react-router-dom";
import { CALCOM_DEMO_URL } from "../config/demo";


const LINKS = {
  Product: [
    { label: "Features", href: "/features" },
    { label: "Pricing", href: "/pricing" },
    { label: "How It Works", href: "/how-it-works" },
    { label: "ROI Calculator", href: "/roi-calculator" },
    { label: "Customer Stories", href: "/customers" },
  ],
  Solutions: [
    { label: "For Cleaning", href: "/for-cleaning" },
    { label: "For Lawn Care", href: "/for-lawn-care" },
    { label: "For Pest Control", href: "/for-pest-control" },
    // LAUNCH HIDDEN: re-enable when comparison pages go live
    // { label: "vs. Jobber", href: "/vs-jobber" },
    // { label: "vs. Housecall Pro", href: "/vs-housecall-pro" },
  ],
  Company: [
    { label: "About", href: "/about" },
    { label: "Customer Stories", href: "/customers" },
    { label: "Blog", href: "/blog" },
  ],
  Legal: [
    { label: "FAQ", href: "/faq" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Service", href: "/terms-of-service" },
    { label: "SMS Program", href: "/sms-program" },
  ],
  Support: [
    { label: "Book a Demo", href: CALCOM_DEMO_URL },
    { label: "Contact Us", href: "/contact" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0F] border-t border-[#1E1E2E]">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="md:col-span-2 space-y-3">
            <Link to="/" className="inline-flex items-center gap-2.5" data-testid="footer-logo">
              <img
                src="/cleanbid-logo-transparent.png"
                alt="CleanBid.ai"
                style={{ height: "40px", width: "auto", opacity: 1, transition: "opacity 200ms ease" }}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.8"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
              />
              <span className="text-xl font-bold tracking-tight text-[#F5F7FA] leading-none">
                CleanBid<span className="text-[#71DED6]">.ai</span>
              </span>
            </Link>
            <p className="text-[#8B8BA7] text-sm leading-relaxed max-w-xs">
              Close jobs. Collect reviews. Grow.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(LINKS).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-[#F4F4F8] text-sm font-semibold mb-4 uppercase tracking-widest text-xs">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith("mailto:") || link.href.startsWith("http") ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-[#8B8BA7] hover:text-[#F4F4F8] text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-[#8B8BA7] hover:text-[#F4F4F8] text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-[#1E1E2E] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#8B8BA7] text-sm">
            &copy; {new Date().getFullYear()} CleanBid.ai. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-[#8B8BA7]">
            <Link to="/privacy-policy" className="hover:text-[#F4F4F8] transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-[#F4F4F8] transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
